<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M6 22L7 2H17L18 22H6ZM11 4H13V6H11V4ZM11 9H13V11H11V9ZM11 14H13V16H11V14ZM11 19H13V21H11V19Z"
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
